import { track as eventTracker } from '@chama/utils/functions/analytics';

const track = (eventName, properties) => {
  try {
    eventTracker(eventName, properties);
  } catch (e) {
    console.error(e);
  }
};

export default track;



// WEBPACK FOOTER //
// ./src/util/analytics-handler.js